function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h512v341.337H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 170.663
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M339.465 255.994l-34.104 16.042 18.161 33.031-37.035-7.085-4.691 37.409L256 307.879l-25.795 27.512-4.693-37.409-37.033 7.083 18.161-33.031-34.105-16.04 34.106-16.04-18.162-33.033 37.031 7.087 4.696-37.41L256 204.111l25.797-27.513 4.69 37.41 37.036-7.087-18.161 33.034z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 51.942,
  fill: "#d80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M230.029 255.994c-1.251 0-2.487.063-3.705.186a29.551 29.551 0 006.947 18.894 52.064 52.064 0 0110.035-16.614 36.902 36.902 0 00-13.277-2.466zm15.988 27.956c3.12 1.114 6.48 1.726 9.983 1.726s6.863-.611 9.983-1.726A37.122 37.122 0 00256 266.634a37.122 37.122 0 00-9.983 17.316zm35.685-42.791c-5.132-8.871-14.717-14.845-25.702-14.845s-20.571 5.974-25.704 14.845A51.61 51.61 0 01256 248.143a51.6 51.6 0 0125.702-6.984zm-13.007 17.301a52.02 52.02 0 0110.035 16.614 29.555 29.555 0 006.947-18.894 36.898 36.898 0 00-16.982 2.28z",
  fill: "#ffda44"
});

const SvgKyrgyzstan = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKyrgyzstan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kyrgyzstan.0dab4954.svg";
export { ForwardRef as ReactComponent };